import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import s from '../TourGuideAi.module.scss';
import SiteSeeContext from '../../SiteSeeGuides/SiteSeeContext';
import Modal from '../../Modal/Modal';
import ModalContentBasic from '../../Modal/ModalContentBasic';
import tourGuideAiLogo from '../tourguide-ai.jpg';

const CTA = ({
  panelIsOpen, onStartTour, modalStyle, arrowStyle, communityName,
}) => {
  const { showSiteSeeGuide, siteSeeGuideMode } = useContext(SiteSeeContext);

  const [showCTA, setShowCTA] = useState(false);
  const [ctaSuppressed, setCtaSuppressed] = useState(false);

  // Show CTA after SiteSee cycle completes (tip mode), with a 2s delay.
  useEffect(() => {
    if (
      !showSiteSeeGuide
      && siteSeeGuideMode === 'tip'
      && !ctaSuppressed
      && !panelIsOpen
    ) {
      const timer = setTimeout(() => {
        if (!ctaSuppressed && !panelIsOpen) {
          setShowCTA(true);
        }
      }, 2000);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, [showSiteSeeGuide, siteSeeGuideMode, ctaSuppressed, panelIsOpen]);

  // When the panel opens, dismiss the CTA and suppress it for the session.
  useEffect(() => {
    if (panelIsOpen) {
      setShowCTA(false);
      setCtaSuppressed(true);
    }
  }, [panelIsOpen]);

  const buttons = [{
    text: 'Start Tour',
    func: () => {
      setShowCTA(false);
      onStartTour();
    },
    className: 'modal__btn modal_btn--primary',
  },
  {
    text: 'Maybe Later',
    func: () => {
      setShowCTA(false);
    },
    className: 'modal__btn--minor',
  }];

  const hasArrow = arrowStyle && Object.keys(arrowStyle).length > 0;

  if (!showCTA) return null;

  return (
    <Modal
      isOpen
      modalClassName="modal--positioned modal--small modal--centered"
      modalStyle={modalStyle}
      showBlur={false}
    >
      {hasArrow && (
        <div
          className="modal__arrow"
          style={arrowStyle}
        />
      )}
      <ModalContentBasic
        title={(
          <span className={s.titleContent}>
            <span>Welcome to</span>
            <img src={tourGuideAiLogo} alt="TourGuide AI" className={s.titleLogo} />
          </span>
        )}
        titleLength="long"
        text={`Join us on an AI-guided tour of ${communityName || 'our community'}, built around your interests, and receive a personalized interactive brochure.`}
        textLength="short"
        buttons={buttons}
      />
    </Modal>
  );
};

CTA.propTypes = {
  panelIsOpen: PropTypes.bool.isRequired,
  onStartTour: PropTypes.func.isRequired,
  modalStyle: PropTypes.shape({}),
  arrowStyle: PropTypes.shape({}),
  communityName: PropTypes.string,
};

CTA.defaultProps = {
  modalStyle: {},
  arrowStyle: {},
  communityName: null,
};

export default CTA;
